'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidHistoryIfNeeded = exports.isBidHistoryLoading = exports.getLoadTimeForBidHistory = exports.getBidHistory = exports.LOAD_BID_HISTORY_SUCCESS = exports.LOAD_BID_HISTORY_REQUEST = exports.LOAD_BID_HISTORY_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BID_HISTORY_FAIL = exports.LOAD_BID_HISTORY_FAIL = 'la/domain/bidHistory/LOAD_FAIL';
var LOAD_BID_HISTORY_REQUEST = exports.LOAD_BID_HISTORY_REQUEST = 'la/domain/bidHistory/LOAD_REQUEST';
var LOAD_BID_HISTORY_SUCCESS = exports.LOAD_BID_HISTORY_SUCCESS = 'la/domain/bidHistory/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_BID_HISTORY_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_BID_HISTORY_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_BID_HISTORY_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends4.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.itemId, time));
            loading = (0, _cloneDeep2.default)(state.loading);

            existing[action.meta.itemId] = action.payload;
            loading = (0, _difference2.default)(loading, [action.meta.itemId]);
            return (0, _extends4.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.bidHistory;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBidHistory = exports.getBidHistory = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getLoadTimeForBidHistory = exports.getLoadTimeForBidHistory = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isBidHistoryLoading = exports.isBidHistoryLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchBidHistory = (0, _reselect.createSelector)([idSelector, getBidHistory, getLoadTimeForBidHistory, isBidHistoryLoading], function (catalogId, bidHistory, loaded, loading) {
    if (!catalogId) return false;
    if (bidHistory) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchBidHistoryIfNeeded = exports.fetchBidHistoryIfNeeded = function fetchBidHistoryIfNeeded(itemId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchBidHistory(state, itemId)) {
                                _context.next = 17;
                                break;
                            }

                            _context.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: itemId,
                                type: LOAD_BID_HISTORY_REQUEST
                            });
                            _context.next = 8;
                            return _api.BidHistory.fetchBidHistory({ authToken: authToken, deployment: deployment, itemId: itemId });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: itemId },
                                payload: response.data,
                                type: LOAD_BID_HISTORY_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](2);

                            dispatch({
                                error: true,
                                meta: { itemId: itemId },
                                payload: _context.t0,
                                type: LOAD_BID_HISTORY_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/bidHistory.js
// module id = vx4l
// module chunks = 46